


















































import Vue from "vue";
import axios, { AxiosResponse } from "axios";
import * as firebase from "firebase/app";
import { API_BASE_URL } from "@/shared/global-values";

export default Vue.extend({
  data() {
    return {
      email: "",
      showCodeInput: false,
      codeIsInvalid: false,
      isDisabled: false,
      isDisabledAuth: false,
    };
  },
  methods: {
    async verifyEmail(event: Event): Promise<void> {
      this.isDisabled = true;
      this.codeIsInvalid = false;

      const form: HTMLFormElement = event.currentTarget as HTMLFormElement;
      const formData: FormData = new FormData(form);

      try {
        await axios.post(`${API_BASE_URL}/auth/verify_email`, formData, { withCredentials: true });
        this.showCodeInput = true;
        this.isDisabled = false;

      } catch (error) {
        console.error(error);
      }
    },
    async authenticate(event: Event): Promise<void> {
      this.isDisabledAuth = true;
      this.codeIsInvalid = false;

      const form: HTMLFormElement = event.currentTarget as HTMLFormElement;
      const formData: FormData = new FormData(form);

      try {
        const response: AxiosResponse = await axios.post(`${API_BASE_URL}/auth/authenticate`, formData, { withCredentials: true });

        await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        await firebase.auth().signInWithCustomToken(response.data.token);

      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.isDisabledAuth = false;
          this.codeIsInvalid = true;
        } else {
          console.error(error);
        }
      }
    },
  },
});
